import { __awaiter } from "tslib";
import { Subject, Subscription } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import * as i0 from "@angular/core";
export class MessagingWorkerProxyService {
    constructor(injector) {
        this.injector = injector;
        this.sendbirdChatConnectionState$ = new Subject();
        this.channelCollectionHandlerEvents$ = new Subject();
        this.swChannelHandlerEvents$ = new Subject();
        this.swLoadPreviousMessages$ = new Subject();
        this.subscriptions = new Subscription();
    }
    connectWithSharedWorker() {
        return __awaiter(this, void 0, void 0, function* () {
            // tslint:disable-next-line: no-shadowed-variable
            const { MessagingSharedWorkerHandlerService } = yield import('@app/dashboard/messaging/services/messaging-shared-worker-handler.service');
            this.messagingSharedWorkerHandlerService = this.injector.get(MessagingSharedWorkerHandlerService);
            this.initSharedWorkerProcesses();
        });
    }
    initSharedWorkerProcesses() {
        this.messagingSharedWorkerHandlerService.initSharedWorker();
        this.messagingSharedWorkerHandlerService.initSendbirdConnection();
        this.subscriptions.unsubscribe();
        this.subscriptions = new Subscription();
        this.subscriptions.add(this.initSendbirdMessageStream());
        this.subscriptions.add(this.initChannelCollectionHandlerStream());
        this.subscriptions.add(this.initChannelHandlerStream());
        this.subscriptions.add(this.initMessageListUpdateStream());
    }
    getTotalUnreadChannelCount() {
        return this.messagingSharedWorkerHandlerService.getTotalUnreadChannelCount();
    }
    fetchChannel(fetchChannelOption, includePreviousPages = false) {
        return this.messagingSharedWorkerHandlerService.fetchChannel(fetchChannelOption, includePreviousPages);
    }
    fetchChannelFromCache(channelUrl) {
        return this.messagingSharedWorkerHandlerService.fetchChannelFromCache(channelUrl);
    }
    fetchMessages(channelUrl) {
        this.messagingSharedWorkerHandlerService.fetchMessages(channelUrl);
    }
    loadPreviousMessages(channelUrl) {
        return this.messagingSharedWorkerHandlerService.loadPreviousMessages(channelUrl);
    }
    startTyping(channelUrl) {
        this.messagingSharedWorkerHandlerService.startTyping(channelUrl);
    }
    endTyping(channelUrl) {
        this.messagingSharedWorkerHandlerService.endTyping(channelUrl);
    }
    markAsRead(channelUrl) {
        return this.messagingSharedWorkerHandlerService.markAsRead(channelUrl);
    }
    createChannel(groupChannelParams) {
        return this.messagingSharedWorkerHandlerService.createChannel(groupChannelParams);
    }
    getNonTeamChannelsByIds(userIds) {
        return this.messagingSharedWorkerHandlerService.getNonTeamChannelsByIds(userIds);
    }
    banUser(banUserParams) {
        return this.messagingSharedWorkerHandlerService.banUser(banUserParams);
    }
    unBanUser(unBanUserParams) {
        return this.messagingSharedWorkerHandlerService.unBanUser(unBanUserParams);
    }
    createBannedUserListQuery(channelUrl) {
        return this.messagingSharedWorkerHandlerService.createBannedUserListQuery(channelUrl);
    }
    addUsers(channelUrl, userIds) {
        return this.messagingSharedWorkerHandlerService.addUsers(channelUrl, userIds);
    }
    updateChannelToDistinct(channelUrl) {
        return this.messagingSharedWorkerHandlerService.updateChannelToDistinct(channelUrl);
    }
    leaveChannel(channelUrl) {
        return this.messagingSharedWorkerHandlerService.leaveChannel(channelUrl);
    }
    createAndSendUserMessage(channel, messageBody, fileMessageData) {
        if (fileMessageData) {
            return this.messagingSharedWorkerHandlerService.createAndSendUserMessageFileImprovementsEnabled(channel, messageBody, fileMessageData);
        }
        return this.messagingSharedWorkerHandlerService.createAndSendUserMessage(channel, messageBody);
    }
    getTeamChannel(driverIds, customType) {
        return this.messagingSharedWorkerHandlerService.getTeamChannel(driverIds, customType);
    }
    disconnect() {
        return this.messagingSharedWorkerHandlerService.disconnect();
    }
    logout() {
        return this.messagingSharedWorkerHandlerService.logout();
    }
    initSendbirdMessageStream() {
        return this.messagingSharedWorkerHandlerService.swWebSocketConnectionState$
            .subscribe((connectionState) => {
            this.sendbirdChatConnectionState$.next(connectionState);
        });
    }
    initChannelCollectionHandlerStream() {
        return this.messagingSharedWorkerHandlerService.swChannelCollectionHandlerEvents$
            .subscribe((channelEvents) => {
            this.channelCollectionHandlerEvents$.next(channelEvents);
        });
    }
    initChannelHandlerStream() {
        return this.messagingSharedWorkerHandlerService.swChannelHandlerEvents$
            .subscribe((channelEvents) => {
            this.swChannelHandlerEvents$.next(channelEvents);
        });
    }
    initMessageListUpdateStream() {
        return this.messagingSharedWorkerHandlerService.swLoadPreviousMessages$
            .subscribe((messageUpdateEvent) => {
            this.swLoadPreviousMessages$.next(messageUpdateEvent);
        });
    }
}
MessagingWorkerProxyService.ɵfac = function MessagingWorkerProxyService_Factory(t) { return new (t || MessagingWorkerProxyService)(i0.ɵɵinject(i0.Injector)); };
MessagingWorkerProxyService.ɵprov = i0.ɵɵdefineInjectable({ token: MessagingWorkerProxyService, factory: MessagingWorkerProxyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagingWorkerProxyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();
